<template>
  <div>
    <px-view-header title="Tabelas de preço" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-tabela-preco-listagem-header :on-click-refresh="onClickRefresh"
                                     :on-change-filter="onChangeFilter"
                                     @change="onChangeFilter"/>
    <px-tabela-preco-lista :tabelas-preco="tabelasPreco"
                           :loading="loading"
                           :on-change-options="onChangeOptions"
                           :options-list="optionsList"
                           :footer-options="footerOptions"
                           @remove="onRemove"
                           @update="onClickRefresh"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-tabelas-preco/actions.type';
import TabelaPrecoListagemHeader from '@/modules/tabela-preco/TabelaPrecoListagemHeader.vue';
import paginationMixin from '@/mixins/pagination-mixin';
import TabelaPrecoService from '@/modules/tabela-preco/tabela-preco-service';
import TabelaPrecoLista from '@/modules/tabela-preco/TabelaPrecoLista.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      tabelasPreco: {
        content: [],
        total: 0,
      },
      optionsList: {},
      loading: false,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Tabelas de preço' },
      ],
    };
  },
  computed: {
    ...mapGetters('listagemTabelasPreco', ['stringFilter', 'listOptions']),
    ...mapGetters('entidade', ['idEntidade']),
    ...mapGetters('user', ['user']),
  },
  methods: {
    ...mapActions('listagemTabelasPreco', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.updateFilter(this.stringFilter);
      this.resetPage();
      this.getTabelasPreco();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getTabelasPreco();
    },
    onClickRefresh() {
      this.getTabelasPreco();
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getTabelasPreco() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return TabelaPrecoService.getTabelasPreco({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.tabelasPreco = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
    onRemove(tabelaPreco) {
      this.loading = true;
      return TabelaPrecoService.remove(tabelaPreco.id)
        .then(() => {
          this.$toast('Tabela de preço removida', { color: 'success' });
          return this.getTabelasPreco();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxTabelaPrecoLista: TabelaPrecoLista,
    pxTabelaPrecoListagemHeader: TabelaPrecoListagemHeader,
  },
};
</script>
